import { ChevronDown } from "../../../ui";

const SettingsSection = ({ title, hint, isOpen, onToggle, children }) => (
  <div className={`billing-ledger-group billing-settings-section ${isOpen ? "open" : ""}`}>
    <button type="button" className="billing-ledger-group-head" onClick={onToggle}>
      <div>
        <strong>{title}</strong>
        {hint && <span className="billing-ledger-group-sub">{hint}</span>}
      </div>
      <ChevronDown className="billing-settings-chevron" size={18} />
    </button>
    {isOpen && <div className="billing-ledger-group-body">{children}</div>}
  </div>
);

export default SettingsSection;
